export default __webpack_public_path__ + "static/media/space.c435100a.png";